import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M11.251 18.25v-9a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5v7-9a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5v9-7a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5v7-4.5a1.5 1.5 0 0 1 1.5-1.5v0c.828 0 1.5.67 1.5 1.499v8.501c0 3.75-3 6-6.5 6-3 0-4.5-1-6-3-3.5-5-4.51-5-4.5-6.5-.001-.85.649-1.5 1.5-1.5 1 0 2 1 3.5 3"
    }
  )
);
var SvgOpenHandOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var OpenHandOutlined_default = SvgOpenHandOutlined;

export { OpenHandOutlined_default as default };
